import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import AppShell from './components/layout/AppShell.jsx';
import DashboardPage from './pages/DashboardPage.jsx';
import ClientsPage from './pages/ClientsPage.jsx';
import ClientDetailPage from './pages/ClientDetailPage.jsx';
import ServicesPage from './pages/ServicesPage.jsx';
import QuotesPage from './pages/QuotesPage.jsx';
import SettingsPage from './pages/SettingsPage.jsx';
import { AuthProvider, ProtectedRoute } from './contexts/AuthContext.jsx';
import LoginPage from './pages/LoginPage.jsx';
import RegisterPage from './pages/RegisterPage.jsx';
import ForgotPage from './pages/ForgotPage.jsx';
import ResetPasswordPage from './pages/ResetPasswordPage.jsx';
import ResetPinPage from './pages/ResetPinPage.jsx';

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot" element={<ForgotPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/reset-pin" element={<ResetPinPage />} />
          <Route path="/" element={
            <ProtectedRoute>
              <AppShell />
            </ProtectedRoute>
          }>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="clients"       element={<ClientsPage />} />
            <Route path="clients/:id"   element={<ClientDetailPage />} />
            <Route path="listino"      element={<ServicesPage />} />
            <Route path="preventivi"   element={<QuotesPage />} />
            <Route path="impostazioni" element={<SettingsPage />} />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
